var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.781,
    height: 55,
    viewBox: "0 0 31.781 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #004057;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 5px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconos-08",
    className: "cls-1",
    d: "M25.414,51.168V30.53a.617.617,0,0,1,.618-.618l6.143-.459a.623.623,0,0,0,.613-.524l1.2-7.351a.62.62,0,0,0-.613-.712H26.032a.617.617,0,0,1-.618-.618V14.994c0-2.477,1.213-4.888,5.1-4.888h3.329a.617.617,0,0,0,.618-.618V2.933a.616.616,0,0,0-.524-.613,47.043,47.043,0,0,0-6.485-.529c-7.15,0-11.827,4.336-11.827,12.183v6.279a.617.617,0,0,1-.618.618H8.3a.617.617,0,0,0-.618.618V29.3a.617.617,0,0,0,.618.618h6.709a.617.617,0,0,1,.618.618V51.173a.617.617,0,0,0,.618.618h8.545a.617.617,0,0,0,.618-.618Z",
    transform: "translate(-5.184 0.709)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3b85dc0b989776c32353cf34d6ddf51b.svg";
export { ForwardRef as ReactComponent };